import React from "react"
import { Card, CardBody, Row, Col, Container } from "reactstrap"

const Present = ({ studData }) => {
  const defaultUrl = "https://commonfiles.prisms.in/commonfiles/avatar.jpg"
  return (
    <div
      style={{
        height: "100%",
        backgroundColor: "#211689",
        overflowY: "scroll",
        scrollBehavior: "smooth",
      }}
    >
      <style>
        {`
          ::-webkit-scrollbar {
            display: none;
          }
          scrollbar-width: none;
          -ms-overflow-style: none;
        `}
      </style>

      <Container fluid className="p-0">
        {studData &&
          studData.data.length > 0 &&
          studData.data.map((item, idx) => (
            <Card
              key={idx}
              className="m-2 p-0"
              style={{ border: "2px solid #90EE90", borderRadius: "5px" }}
            >
              <CardBody className="p-2">
                <Row className="align-items-center p-0">
                  <Col xs="auto">
                    <img
                      src={item.avatar ? item.avatar : defaultUrl}
                      alt="avatar"
                      width={70}
                      height={70}
                      // style={{ borderRadius: "50%" }}
                    />
                  </Col>
                  <Col>
                    <h6 className="mb-1 fw-bold text-dark" style={{ fontSize: 14 }}>
                      {item.stud_name}
                    </h6>
                    <p
                      className="mb-1"
                      style={{ fontSize: 13, color: "#c3cfff" }}
                    >
                      {item.routename}
                    </p>
                    <p className="mb-0" style={{ fontSize: 13 }}>
                      {item.event === "pickup" ? "Pick up" : "Drop"}:{" "}
                      <span
                        style={{
                          color: `${
                            item.event === "pickup" ? "#1AD87F" : "#FF0000"
                          }`,
                          fontWeight: "bold",
                        }}
                      >
                        {item.pickupTime ? item.pickupTime : item.dropTime}
                      </span>
                    </p>
                        <p
                      className="mb-1"
                      style={{ fontSize: 13, color: "#111" }}
                    >
                      {item.div_name}
                    </p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
      </Container>
    </div>
  )
}

export default Present
